import React, { Component } from "react";

class SignUp extends Component {
  handleSubmit = (e) => {
    e.preventDefault();
    const { handleClick, subscribe } = this.props;
    handleClick();
    subscribe();
  }

  render() {
    const { onChange } = this.props;

    return (
      <form className="form mt-4 mb-5">
        <div className="input-group mb-3">
          <input
            type="text"
            className="form-control form-control-lg py-3 pl-4 pr-4"
            placeholder="Your email address"
            name="subscription_email"
            onChange={onChange}
            pattern=""
          />
          <div className="input-group-append">
            <button
              className=" btn-warning btn-lg ml-3  py-3 pl-5 pr-5 text-white"
              type="button"
              onClick={this.handleSubmit}
            >
              Get Started
            </button>
          </div>
        </div>
      </form>
    );
  }
}

export default SignUp;



// WEBPACK FOOTER //
// ./src/components/LandingPage/SignUp.js